import React from 'react';
import classNames from 'classnames';
import './SkeletonLoader.less';
import { DebounceComponent } from 'components/DebounceComponent';

export interface ISkeletonLoaderProps {
  height: number;
  title?: string;
  style?: React.CSSProperties;
}

const getClassName = () => classNames('dpc-skeleton-loader');

const LOADER_ROW_HEIGHT = 42; // 30 + 12 margin-bottom;

/**
 * Basic Skeleton Loader
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function SkeletonLoader({ height, title, style }: ISkeletonLoaderProps) {
  const rowCount = Math.floor(height / LOADER_ROW_HEIGHT);
  const rows: JSX.Element[] = [];
  for (let i = 0; i < rowCount; i++) {
    rows.push(<div key={i} className="dpc-skeleton-loader__row" style={{ width: 100 - Math.random() * 15 + '%' }} />);
  }

  return (
    <DebounceComponent>
      <div title={title} className={getClassName()} style={{ ...style, height: `${height}px` }}>
        {rows}
      </div>
    </DebounceComponent>
  );
}
